import { BrowserRouter, Route, Routes } from "react-router-dom";
import React from "react";
import Layout from "./modules/layout/components";
import Contact from "./modules/contact";
import TermsCondition from "./modules/TermsCondition/components";
import Hardware from "./modules/hardware";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms-and-conditions" element={<TermsCondition />} />
        <Route path="/hardware" element={<Hardware />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
